<template>
  <div class="graph-card" role="graph" title="ACT Average Composite Scores" aria-describedby="act-description">
    <div class="graph-card-header" :style="{'background-color': this.headerColor}">
      <div class="g-heading">
        <h2>ACT Average Composite Score</h2>
        <p>{{ data.years.length }} year stretch</p>
      </div>
      <div
        class="tooltip-icon"
        tabindex="0"
        @mouseenter="toggleTooltip(1)"
        @mouseleave="toggleTooltip(0)"
        @keydown.enter="toggleTooltip(1)"
        @keyup.enter="toggleTooltip(0)">
      </div>
    </div>
    <div class="graph-card-body" :style="{'background-color': this.bodyColor}">
      <cmps-line :data="chartData" :options="chartOptions" :styles="stylesObject" aria-hidden="true"></cmps-line>
      <div class="tooltip-text" ref="tooltip" aria-hidden="true">
        <p id="act-description">The ACT is a standardized test widely used for college admissions across the United States. Students are tested on Mathematics, English, Reading, Writing, and Science.</p>
      </div>
      <table class="sr-only">
        <thead>
          <tr>
            <th>Year</th>
            <th>Average Score</th>
          </tr>
        </thead>
        <tbody>
          <tr :key="index" v-for="(data, index) in tableData">
            <td>{{ data.year }}</td>
            <td>{{ data.score }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div> <!-- end graph-card -->
</template>

<script>
  import Line from './charts/Line.vue'

  export default {
    components: {
      cmpsLine: Line
    },
    props: ['data', 'headerColor', 'bodyColor'],
    computed: {
      chartData() {
        return {
          datasets: [
            {
              data: this.data.scores,
              fill: false,
              borderColor: '#fff',
              pointBackgroundColor: this.headerColor,
              pointBorderColor: this.headerColor,
              pointBorderWidth: 5
            }
          ],
          labels: this.data.years
        }
      },
      tableData() {
        let arr = []
        this.data.years.forEach((e, i) => {
          arr.push({ year: e, score: this.data.scores[i]})
        })
        return arr
      }
    },
		data() {
			return {
        chartOptions: {
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          scales: {
            yAxes: [{
              gridLines: {
                color: '#000',
              },
              ticks: {
                fontColor: '#000',
                min: 16,
                 max: 30,
                // stepSize: 50
              }
            }],
            xAxes: [{
              gridLines: {
                color: '#000'
              },
              ticks: {
                fontColor: '#000'
              }
            }]
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                return '  ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              }
            }
          },
          plugins: {
            deferred: {
              yOffset: '75%',
              delay: 500
            }
          }
        },
        stylesObject: {
          // height: '350px',
          position: 'relative'
        }
      }
		},
    methods: {
      toggleTooltip(value) {
        this.$refs.tooltip.style.left = value === 1 ? '0' : '99999px'
        this.$refs.tooltip.style.opacity = value
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/_graphs.scss';
</style>
